<template>
	<vx-card :noShadow="true">
		<p>{{ $t("Follower.SearchVisitByDateText") }}</p>
		<div class="vx-row mt-4">
			<div class="vx-col w-full">
				<small class="date-label"> {{ $t("Follower.SearchVisitByDate") }}. </small>
				<datepicker :language="$vs.rtl ? langHe : langEn" name="start-date" v-model="initDate"></datepicker>
			</div>

			<div class="vx-col w-full mt-2">
				<small class="date-label"> {{ $t("Follower.SetDateRange") }}</small>
				<datepicker
					:language="$vs.rtl ? langHe : langEn"
					:disabledDates="disabledDatesTo"
					name="new-date"
					v-model="endDate"
				></datepicker>
			</div>
		</div>

		<p class="mt-base">{{ $t("Schedule.ListofEventsDay") }}</p>

		<vs-divider class="d-theme-border-grey-light" />

		<vue-perfect-scrollbar :style="scrollArea" :settings="settings">
			<div v-if="dataEvents.length > 0">
				<ul class="bordered-items">
					<li
						class="cursor-pointer border p-3 hover:font-semibold flex items-center card-resource-list-item"
						v-for="event in dataEvents"
						:key="event.id"
						:title="$t('Select')"
						@click="$emit('select', event)"
					>
						<feather-icon
							icon="CalendarIcon"
							svgClasses="w-5 h-5 hover:text-success stroke-current"
							class="mr-2"
						/>

						{{ resolveText(event) | capitalize }}
					</li>
				</ul>
			</div>

			<div v-else>
				<p>{{ $t("Follower.SearchVisitNotFound") }}</p>
			</div>
		</vue-perfect-scrollbar>
	</vx-card>

	<!-- <transition name="slide-fade">
				<div class="vx-col w-full sm:w-3/3 md:w-1/3" v-if="selectedEvents.length > 0">
					<resource-list
						ref="ResourceList"
						:title="$t('Schedule.ResourceList')"
						componentParent="REASSIGN_EVENTS"
						:resource_ids="[]"
					>
						<template v-slot:text>
							<p>Seleccione el nuevo recurso para reasignar las visitas seleccionadas</p>
						</template>
					</resource-list>
				</div>
			</transition> -->
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {en, es, tr} from "vuejs-datepicker/src/locale";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateUtils from "@/helpers/DateUtils.js";

import moduleSchedule from "@/store/schedule/moduleSchedule.js";

export default {
	name: "FollowerFormEventSelection",
	components: {
		VuePerfectScrollbar,
		Datepicker,
	},
	props: {
		resourceId: {
			type: Number,
			default: 0,
		},
		scrollArea: {
			type: Object,
			default: () => {
				return {
					margin: " auto",
					width: " 100%",
					height: " 350px",
				};
			},
		},
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
			},
			currentDay: new Date(),
			initDate: new Date(),
			endDate: null,
			langHe: es,
			langEn: en,
		};
	},
	computed: {
		dataEvents() {
			return this.$store.state.moduleSchedule.events;
		},

		disabledDatesTo() {
			const date = this.addOrLessDaysToDate(new Date(), -1);
			return {to: new Date(date)};
		},
		disabledDatesFrom() {
			return {from: new Date(this.currentDay)};
		},
		resolveText() {
			return ({date_prog, init_hour, activity_name, visit_point_name}) => {
				return `${date_prog} - ${init_hour} - ${activity_name},  ${visit_point_name} `;
			};
		},
	},

	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async fetchEvents(
			dateInit = DateUtils.toDefaultDateTime(this.initDate, "YYYY-MM-DD"),
			endDate = DateUtils.toDefaultDateTime(this.initDate, "YYYY-MM-DD")
		) {
			try {
				this.openLoading();
				const payload = {
					init_date: dateInit,
					end_date: endDate,
					resource_id: this.resourceId,
				};
				await this.$store.dispatch("moduleSchedule/fetchEventsByResourceId", payload);
			} catch (error) {
				console.error("Error fetching events", error);
			} finally {
				this.closeLoading();
			}
		},
		addOrLessDaysToDate(stringDate, days) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + days);
		},
	},
	watch: {
		initDate(val) {
			if (this.resourceId && val) this.fetchEvents();
		},
		endDate(val) {
			if (val) {
				this.fetchEvents(
					DateUtils.toDefaultDateTime(this.initDate, "YYYY-MM-DD"),
					DateUtils.toDefaultDateTime(val, "YYYY-MM-DD")
				);
			}
		},
		resourceId(val) {
			if (val) this.fetchEvents();
		},
	},
	mounted() {
		//this.initDate = this.currentDay;
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
};
</script>

<style scoped lang="scss">
.card-resource-list-item:hover {
	background: #f5f5f5;
	cursor: pointer;
}
</style>
